import { BASE_URL } from 'constants/api';

import { createGetAPI, createPostAPI } from '@cuemath/rest-api';

const { useGet: getStudentTransferStatus } = createGetAPI({
  getURL: studentId => `${BASE_URL}/students/${studentId}/direct-transfer/`,
});

const { usePost: postStudentTransferStatus } = createPostAPI({
  getURL: (queryParam, studentId) => `${BASE_URL}/students/${studentId}/direct-transfer/`,
});

const { usePost: postStartTransferProcess } = createPostAPI({
  getURL: (queryParam, studentId) =>
    `${BASE_URL}/students/${studentId}/direct-transfer/start-process/`,
});

export { postStudentTransferStatus, getStudentTransferStatus, postStartTransferProcess };
